document.querySelectorAll('.vdo-btn-click').forEach((button) => {
  const thumbWrap = button.closest('.thumb-btn-wrap');
  if (!thumbWrap) return;

  const videoSec = thumbWrap.closest('.video-sec');
  if (!videoSec) return;

  const video = videoSec.querySelector('#vdo-play');
  if (!video) return;

  video.addEventListener('pause', () => {
    thumbWrap.style.display = 'flex';
  });

  video.addEventListener('ended', () => {
    thumbWrap.style.display = 'flex';
  });

  button.addEventListener('click', () => {
    video.muted = true;
    video.play().catch((err) => {
      console.warn('Playback blocked:', err);
    });
    thumbWrap.style.display = 'none';
  });
});

function initIndexBannerSlider(slider) {
  if (!slider) return;
  if (slider.splide) return;

  const isDesignMode = slider.dataset.isDesignMode === 'true';

  const splide = new Splide(slider, {
    type: 'fade',
    rewind: true,               
    perPage: 1,
    arrows: false,
    pagination: false,
    autoplay: !isDesignMode,
    interval: 4000,
    speed: 800,
    pauseOnHover: false,
    pauseOnFocus: false,
  });

  splide.mount();
  slider.splide = splide;

  /* ---------- Custom SVG pagination ---------- */
  const pagination = document.createElement('div');
  pagination.className = 'custom-pagination';

  for (let i = 0; i < splide.length; i++) {
    const btn = document.createElement('button');
    btn.className = 'pagination-item';
    btn.innerHTML = `
      <svg class="progress-circle" viewBox="0 0 36 36">
        <circle class="progress-bg" cx="18" cy="18" r="16"></circle>
        <circle class="progress-bar" cx="18" cy="18" r="16"></circle>
      </svg>
    `;
    btn.addEventListener('click', () => splide.go(i));
    pagination.appendChild(btn);
  }

  slider.appendChild(pagination);

  const items = pagination.querySelectorAll('.pagination-item');
  const interval = splide.options.interval;

  /* ---------- SYNC FUNCTION (ONE ONLY) ---------- */
  function activate() {
    const index = splide.index;

    items.forEach((item, i) => {
      const bar = item.querySelector('.progress-bar');
      bar.style.animation = 'none';

      if (i === index) {
        void bar.offsetWidth; // force reflow
        bar.style.animation = `progressStroke ${interval}ms linear forwards`;
      }
    });

    // 🔑 fix autoplay delay
    if (splide.Components && splide.Components.Autoplay) {
      splide.Components.Autoplay.pause();
      splide.Components.Autoplay.play();
    }
  }

  splide.on('mounted move', activate);
  activate();
}


function autoInitSliders() {
  document.querySelectorAll('.js-index-banner').forEach((slider) => {
    initIndexBannerSlider(slider);
  });

}

autoInitSliders();

document.addEventListener('shopify:section:load', () => autoInitSliders());
document.addEventListener('shopify:section:select', () => autoInitSliders());



  document.addEventListener('DOMContentLoaded', function () {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const buttons = document.querySelectorAll('.grid-btn');

    function updateGrid(columns) {
   
      grid.className = grid.className.replace(/grid--\d+-col-desktop/g, '').trim();

  
      grid.classList.add(`grid--${columns}-col-desktop`);

    
      buttons.forEach(btn => btn.classList.remove('active'));
      document.querySelector(`.grid-btn[data-columns="${columns}"]`)?.classList.add('active');

      
      localStorage.setItem('collectionGridColumns', columns);
    }

   
    buttons.forEach(btn => {
      btn.addEventListener('click', function () {
        updateGrid(this.dataset.columns);
      });
    });

 
    const savedColumns = localStorage.getItem('collectionGridColumns');
    if (savedColumns) {
      updateGrid(savedColumns);
    }
  });

